import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { NgMapsCoreModule } from '@ng-maps/core';
import { SharedModule } from '../../shared/shared.module';
import { AtelierAssignmentsViewComponent } from './atelier-assignments/atelier-assignments-view.component';
import { AtelierAssignmentDetailComponent } from './atelier-detail/assignment/atelier-assignment-detail.component';
import { AtelierItemDetailComponent } from './atelier-detail/item/atelier-item-detail.component';
import { AtelierTaskItemDetailComponent } from './atelier-detail/item/task-item/atelier-task-item-detail.component';
import { AtelierRecoveryComponent } from './atelier-recovery/atelier-recovery.component';
import { AtelierSubProjectViewComponent } from './atelier-detail/assignment/atelier-sub-project-view/atelier-sub-project-view.component';
import { AtelierImmoTaskViewComponent } from './atelier-detail/assignment/atelier-immo-task-view/atelier-immo-task-view.component';
import { RecupJobDetailComponent } from './recup-job-detail/recup-job-detail.component';
import { AtelierSignComponent } from './atelier-sign/atelier-sign.component';
import { StockLocationEditComponent } from 'src/app/components/stock/locations/location-edit.component';
import { StockLocationsOverviewComponent } from 'src/app/components/stock/locations/locations-overview.component';
import { AssociationExamplesComponent } from 'src/app/components/stock/sign-associations/edit-association/assets/association-examples.component';
import { SignPhoneNumberAdjustmentEditComponent } from 'src/app/components/stock/sign-associations/edit-association/phone/sign-phone-number-adjustment-edit.component';
import { SignStickerEditComponent } from 'src/app/components/stock/sign-associations/edit-association/sign-sticker/sign-sticker-edit.component';
import { SignTitleAdjustmentEditComponent } from 'src/app/components/stock/sign-associations/edit-association/title/sign-title-adjustment-edit.component';
import { SignPhoneNumberAdjustmentOverviewComponent } from 'src/app/components/stock/sign-associations/overview/phone/sign-phone-number-adjustment-overview.component';
import { SignAssociationsOverviewComponent } from 'src/app/components/stock/sign-associations/overview/sign-associations-overview.component';
import { SignStickerOverviewComponent } from 'src/app/components/stock/sign-associations/overview/sign-sticker/sign-sticker-overview.component';
import { SignTitleAdjustmentOverviewComponent } from 'src/app/components/stock/sign-associations/overview/title/sign-title-adjustment-overview.component';
import { SignStockEditRequestComponent } from 'src/app/components/stock/sign-stock/edit/sign-stock-edit-request.component';
import { ProductionStockToPhysicalStockComponent } from 'src/app/components/stock/sign-stock/production-stock-to-physical-stock-modal/production-stock-to-physical-stock-modal.component';
import { StockForSignComponent } from 'src/app/components/stock/sign-stock/stock-for-sign.component';
import { SignPhoneNumberAdjustmentPortalOverviewComponent } from 'src/app/components/stock/signs-portal/signs-portal-association-overview/phone/sign-phone-number-adjustment-portal-overview.component';
import { SignStickerPortalOverviewComponent } from 'src/app/components/stock/signs-portal/signs-portal-association-overview/sticker/sign-sticker-portal-overview.component';
import { SignTitleAdjustmentPortalOverviewComponent } from 'src/app/components/stock/signs-portal/signs-portal-association-overview/title/sign-title-adjustment-portal-overview.component';
import { SignsPortalComponent } from 'src/app/components/stock/signs-portal/signs-portal.component';
import { SignDetailExamplesComponent } from 'src/app/components/stock/signs/edit/assets/sign-detail-examples.component';
import { ParticipatingCompanyEditComponent } from 'src/app/components/stock/signs/edit/company/participating-company-edit.component';
import { ConditionalDescriptionComponent } from 'src/app/components/stock/signs/edit/conditional-description.component';
import { ConditionalPriceComponent } from 'src/app/components/stock/signs/edit/conditional-price/conditional-price.component';
import { SignDetailComponent } from 'src/app/components/stock/signs/edit/sign-detail.component';
import { SignEntryComponent } from 'src/app/components/stock/signs/entry/sign-entry.component';
import { SignFromCompanyPickerComponent } from 'src/app/components/stock/signs/picker/sign-from-company-picker.component';
import { SignsOverviewComponent } from 'src/app/components/stock/signs/signs-overview.component';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { AppPipesModule } from 'src/app/modules/app-pipes/app-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    SharedModule,
    NgMapsCoreModule,
    AppPipesModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatTabsModule,
    MatAutocompleteModule,
  ],
  exports: [
    AtelierAssignmentsViewComponent,
    AtelierAssignmentDetailComponent,
    AtelierItemDetailComponent,
    AtelierTaskItemDetailComponent,
    AtelierRecoveryComponent,
    AtelierSignComponent,
    StockLocationsOverviewComponent,
    StockLocationEditComponent,
    SignsPortalComponent,
    SignsOverviewComponent,
    SignTitleAdjustmentPortalOverviewComponent,
    SignPhoneNumberAdjustmentPortalOverviewComponent,
    SignStickerPortalOverviewComponent,
    SignEntryComponent,
    SignDetailComponent,
    SignDetailExamplesComponent,
    ParticipatingCompanyEditComponent,
    ConditionalDescriptionComponent,
    ConditionalPriceComponent,
    StockForSignComponent,
    SignStockEditRequestComponent,
    ProductionStockToPhysicalStockComponent,
    SignAssociationsOverviewComponent,
    SignTitleAdjustmentOverviewComponent,
    SignPhoneNumberAdjustmentOverviewComponent,
    SignStickerOverviewComponent,
    AssociationExamplesComponent,
    SignStickerEditComponent,
    SignTitleAdjustmentEditComponent,
    SignPhoneNumberAdjustmentEditComponent,
    SignFromCompanyPickerComponent,
  ],
  declarations: [
    AtelierAssignmentsViewComponent,
    AtelierAssignmentDetailComponent,
    AtelierItemDetailComponent,
    AtelierTaskItemDetailComponent,
    AtelierRecoveryComponent,
    AtelierSubProjectViewComponent,
    AtelierImmoTaskViewComponent,
    RecupJobDetailComponent,
    AtelierSignComponent,
    StockLocationsOverviewComponent,
    StockLocationEditComponent,
    SignsPortalComponent,
    SignsOverviewComponent,
    SignTitleAdjustmentPortalOverviewComponent,
    SignPhoneNumberAdjustmentPortalOverviewComponent,
    SignStickerPortalOverviewComponent,
    SignEntryComponent,
    SignDetailComponent,
    SignDetailExamplesComponent,
    ParticipatingCompanyEditComponent,
    ConditionalDescriptionComponent,
    ConditionalPriceComponent,
    StockForSignComponent,
    SignStockEditRequestComponent,
    ProductionStockToPhysicalStockComponent,
    SignAssociationsOverviewComponent,
    SignTitleAdjustmentOverviewComponent,
    SignPhoneNumberAdjustmentOverviewComponent,
    SignStickerOverviewComponent,
    AssociationExamplesComponent,
    SignStickerEditComponent,
    SignTitleAdjustmentEditComponent,
    SignPhoneNumberAdjustmentEditComponent,
    SignFromCompanyPickerComponent,
  ],
})
export class AtelierStockModule {}
